import React from 'react'
import "./Info.css"
const info = () => {
  return (
    <div className='info-container'>
        <div className='info'>
            <h1> <strong>HAZ CADA COSA EN LA VIDA COMO SI FUERA LO ÚLTIMO QUE HAGAS. </strong></h1>
        </div>
        
    </div>
  )
}

export default info